<template>
	<div class="page">
		<div class="loading">
			<spinner />
		</div>
	</div>
</template>

<script>
import { mobilePayStatus, finalizeMobilePay } from '@/api/modules/confirm'

export default {
	name: 'PagePaymentStatus',
	mounted() {
		const orderID = this.$route.query.orderId

		if (orderID) {
			mobilePayStatus(orderID).then((response) => {
				const paymentID = response.responseBody.paymentId
				const state = response.responseBody.state.toLowerCase()

				if (state === 'reserved' || state === 'captured') {
					finalizeMobilePay(paymentID, orderID, true).then((response) => {
						if (response.responseBody.error === 'FinalizationWindowExceeded') {
							this.$router.push({ path: '/error', query: { error: 'paymenttimeout' } })
							return
						}

						if (!response.ok) {
							this.$router.push({ path: '/error' })
							return
						}

						this.$router.replace({ path: '/receipt', query: { orderId: orderID } })
					})
				} else {
					this.$router.replace({ path: '/' })
				}
			})
		} else {
			this.$router.replace({ path: '/' })
		}
	},
}
</script>

<style lang="scss" scoped>
.page {
	display: flex;
	height: 100%;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}
</style>
